<template>
    <div class="comMap chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig"  v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">地图名称</span>
            <treeselect  class="treeselectname"  :class="{ mapnameList: $store.state.dpType !==0 }" v-model="config.map.id" :multiple="false" :options="treeoptions" @select="getMapItem"/>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">区域颜色</span>
            <el-color-picker v-model="config.map.itemStyle.areaColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">边界线颜色</span>
            <el-color-picker v-model="config.map.itemStyle.borderColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">高亮颜色</span>
            <el-color-picker v-model="config.map.emphasis.itemStyle.areaColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="nowChart.name.search('GIS')!==-1">
            <span class="span_til">地图主题</span>
            <el-select v-model="config.map.mapStyle" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in mapStyles"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="nowChart.name.search('GIS')!==-1">
            <span class="span_til">中心坐标</span>
            <el-input v-model="config.map.amapMap.center" @change="getRender"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="nowChart.name.search('GIS')!==-1">
            <span class="span_til">缩放级别</span>
            <el-input v-model="config.map.amapMap.zoom" @change="getRender" type="number" min="0" step="0.1"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="nowChart.name.search('GIS')===-1 && nowChart.type.search('3D')==-1" >
            <span class="span_til">缩放级别</span>
            <el-input v-model="config.map.zoom" @change="getRender" type="number" min="0" step="0.1"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <el-checkbox v-model="config.map.label.show" @change="getRender">是否展示文字</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">文字颜色</span>
            <el-color-picker v-model="config.map.label.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="nowChart.name.search('GIS')==-1">
            <span class="span_til">文字大小</span>
            <el-input v-model="config.map.label.fontSize" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="nowChart.name.search('GIS')==-1 && nowChart.type.search('3D')==-1">
            <span class="span_til">阴影颜色</span>
            <el-color-picker v-model="config.map.itemStyle.shadowColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="nowChart.name.search('GIS')==-1 && nowChart.type.search('3D')==-1">
            <span class="span_til">阴影大小</span>
            <el-input v-model="config.map.itemStyle.shadowBlur" @change="getRender" type="number" min="0"></el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */

    // import the component
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {getOption} from '@/assets/axios/mapAxio'

    export default {
        name: 'map_config',
        components: { Treeselect },
        data() {
            return {
                //
                // define the default value
                value: null,
                // define options
                treeoptions: [],
                //jieshu
                mapStyles: [
                    {value: 'normal', label: '标准'},
                    {value: 'dark', label: '幻影黑'},
                    {value: 'light', label: '月光银'},
                    {value: 'whitesmoke', label: '远山黛'},
                    {value: 'fresh', label: '草色青'},
                    {value: 'grey', label: '雅士灰'},
                    {value: 'graffiti', label:'涂鸦'},
                    {value: 'macaron', label: '马卡龙'},
                    {value: 'blue', label: '靛青蓝'},
                    {value: 'darkblue', label: '极夜蓝'},
                    {value: 'wine', label: '酱籽'}
                ],
            }
        },
        computed: {
            config() {
                if (this.$store.state.dpType === 0) {
                    return this.$store.state.viewDP.chart.setting.params;
                } else {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.$store.state.dpType === 0) {
                    return this.$store.state.viewDP.nowChart;
                } else {
                    return this.$store.state.designer.chart;
                }
            }
        },
        methods: {
            //获取当前选中的信息
            getMapItem(val){
                this.config.map.name = val.label;
                this.config.map.mapinfo = val;
                this.getRender();
            },
            // 获取当前选中部门的名称
            getRender() {
                if (this.$store.state.dpType === 0) {
                    this.$store.dispatch('viewDPRender');
                } else if (this.$store.state.dpType === 1) {
                   this.$store.dispatch('screenRender');
                }
            },
            getOptiondata(){
                getOption().then(res => {
                    let data=res.data;
                    let country=[],province=[],city=[];
                    for(var key in data){
                        data[key].id=data[key].adcode;
                        data[key].label=data[key].name;
                        if(data[key].level==="country"){
                            country.push(data[key]);
                        }
                        if(data[key].level==="province"){
                            province.push(data[key]);
                        }
                        if(data[key].level==="city"){
                            city.push(data[key]);
                            delete data[key].children;
                        }
                    }
                    country[0].children=[];
                    country[0].children = province;
                    for(let i=0;i<province.length;i++){
                        if(province[i].name!='北京' && province[i].name!='上海' && province[i].name!='天津'){
                            province[i].children=[];
                            for(let j=0;j<city.length;j++){
                                if(city[j].parent.adcode==province[i].adcode){
                                    province[i].children.push(city[j])
                                }
                            }
                        }else{
                            if(province[i].name=='北京' || province[i].name=='上海' || province[i].name=='天津') {
                                for(let k=0;k<province[i].children.length;k++){
                                    province[i].children[k].id=province[i].children[k].adcode;
                                    province[i].children[k].label=province[i].children[k].name;
                                }
                            }
                        }
                    }
                    this.treeoptions = country;

                })
            }
        },
         mounted() {
             this.getOptiondata();
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .comMap {
        .chartDivConfig{
            .span_til{
                max-width:70px!important;
            }
            .treeselectname{
                 width: calc(100% - 100px - 5px);
                 min-width: 70px;
                 float: left;
                 cursor: pointer;

                 .vue-treeselect__control{
                     line-height: 26px !important;
                     height: 26px !important;
                     background:transparent;
                     letter-spacing: 1px;
                     font-size: 12px;
                     .vue-treeselect__placeholder, .vue-treeselect__single-value{
                         line-height: 26px !important;
                     }

                 }
                 .vue-treeselect__menu-container{
                     font-size: 12px!important;
                     display: block;
                     //滚动条
                     .vue-treeselect__menu{
                         margin-top:3px!important;
                         .vue-treeselect__indent-level-2 {
                             .vue-treeselect__option{
                                 padding-left:26px;
                             }

                         }
                         .vue-treeselect__option--selected{
                             background:#F5F7FA;
                         }
                         &::-webkit-scrollbar {
                             width: 6px!important;
                             height: 1px!important;
                         }

                         &::-webkit-scrollbar-thumb {
                             border-radius: 10px;
                             background:rgba(144, 147, 153, 0.3);

                         }

                         &::-webkit-scrollbar-track {
                             border-radius: 10px;
                             background: transparent;
                         }

                         &::-webkit-scrollbar-thumb:hover {
                             background:rgba(144, 147, 153, 0.5);
                             cursor: pointer !important;
                         }
                     }

                 }
            }
            .mapnameList{
                .vue-treeselect__single-value{
                    color:#fff;
                }
                .vue-treeselect__input{
                    color:#fff;
                }
                .vue-treeselect__menu-container{

                    //滚动条
                    .vue-treeselect__menu::-webkit-scrollbar{
                        width: 6px!important;
                        height: 1px!important;
                    }
                    .vue-treeselect__menu{
                        margin-top:3px!important;
                        background-color: hsl(217.03703704, 55.10204082%, 28.82352941%);
                        border: 1px solid rgba(19, 181, 177, 0.6);
                        color: #fff;
                        &::-webkit-scrollbar {
                            width: 6px!important;
                            height: 1px!important;
                        }
                        &::-webkit-scrollbar-thumb {
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(19, 181, 177, 0.6);
                            background:rgba(0, 96, 153, 0.7);

                        }

                        &::-webkit-scrollbar-track {
                            border-radius: 10px;
                            background: transparent;
                        }

                        &::-webkit-scrollbar-thumb:hover {
                            background: rgba(19, 181, 177, 0.8);
                            cursor: pointer !important;
                        }
                        .vue-treeselect__option--highlight,.vue-treeselect__option--selected{
                            background-color: #375690;
                        }
                    }

                }
            }
        }

    }
</style>